module.exports = __webpack_public_path__ + "static/media/190.d35eb9b0.jpg";